import React, { useEffect, useState } from 'react';
import { PodcastEpisode } from './PodcastEpisode';
import { BackgroundOverlay } from './BackgroundOverlay';
import { NowPlayingPanel } from './NowPlayingPanel';
import { MoodMixCard } from './MoodMixCard';
import { MoodMixModal } from './MoodMixModal';
import { MoodMixLoading } from './MoodMixLoading';
import { MoodMixPlaylist } from './MoodMixPlaylist';
const PODCAST_EPISODES = [{
  id: '1',
  imageUrl: 'https://i.scdn.co/image/ab6765630000ba8a0e7b56d304cfac4bd55b055e',
  title: 'JRE MMA Show #133 with Israel Adesanya',
  description: 'Joe sits down with UFC Middleweight Champion Israel Adesanya to discuss his recent fight and upcoming bout.',
  showTitle: 'The Joe Rogan Experience',
  duration: '2 hr 45 min',
  publishedDate: 'Yesterday',
  hasVideo: true,
  commentsCount: 342
}, {
  id: '2',
  imageUrl: 'https://i.scdn.co/image/ab6765630000ba8a9417936d038e7a2f8dee2554',
  title: 'Work-Life Balance in Tech',
  description: 'In this episode, we discuss strategies for maintaining a healthy work-life balance in the tech industry.',
  showTitle: 'Tech Life Podcast',
  duration: '58 min',
  publishedDate: 'Monday',
  commentsCount: 127
}, {
  id: '3',
  imageUrl: 'https://i.scdn.co/image/ab6765630000ba8a141bbfb6056adda2d057c722',
  title: 'The Future of Artificial Intelligence',
  description: 'Exploring the latest advancements in AI and what they mean for the future of technology and society.',
  showTitle: 'Future Tech Today',
  duration: '1 hr 12 min',
  publishedDate: 'Tuesday',
  hasVideo: true,
  commentsCount: 256
}];
const PLAYLISTS = [{
  id: '1',
  title: 'Liked Songs',
  imageUrl: 'https://misc.scdn.co/liked-songs/liked-songs-640.png',
  description: 'Your favorite songs',
  tracks: 274,
  type: 'playlist'
}, {
  id: '2',
  title: 'Daily Mix 1',
  imageUrl: 'https://dailymix-images.scdn.co/v2/img/ab6761610000e5ebcdce7620dc940db079bf4952/1/en/default',
  description: 'Personalized mix for you',
  tracks: 50,
  type: 'playlist'
}, {
  id: '3',
  title: 'Release Radar',
  imageUrl: 'https://newjams-images.scdn.co/image/ab67647800003f8a/dt/v3/release-radar/ab6761610000e5eb8ae7f2aaa9817a704a87ea36/en',
  description: 'New releases from artists you follow',
  tracks: 30,
  type: 'playlist'
}];
const ALBUMS = [{
  id: '1',
  title: 'After Hours',
  artist: 'The Weeknd',
  imageUrl: 'https://i.scdn.co/image/ab67616d00001e02ef10c30dfca2f5c3a4426b03',
  releaseYear: '2020',
  tracks: 14,
  type: 'album'
}, {
  id: '2',
  title: 'Folklore',
  artist: 'Taylor Swift',
  imageUrl: 'https://i.scdn.co/image/ab67616d00001e02c7d715d68232d3daf5b4eed4',
  releaseYear: '2020',
  tracks: 16,
  type: 'album'
}, {
  id: '3',
  title: 'DAMN.',
  artist: 'Kendrick Lamar',
  imageUrl: 'https://i.scdn.co/image/ab67616d00001e022e02117d76426a81ac0cd493',
  releaseYear: '2017',
  tracks: 14,
  type: 'album'
}, {
  id: '4',
  title: 'Fine Line',
  artist: 'Harry Styles',
  imageUrl: 'https://i.scdn.co/image/ab67616d00001e026b360a502e1beebc4f4ab473',
  releaseYear: '2019',
  tracks: 12,
  type: 'album'
}];
const CURRENT_TRACK = {
  id: '1',
  title: 'Blinding Lights',
  albumArt: 'https://i.scdn.co/image/ab67616d00001e02ef10c30dfca2f5c3a4426b03',
  artists: [{
    id: '1',
    name: 'The Weeknd'
  }]
};
const MOCK_PLAYLIST = {
  mood: 'energized and motivated',
  tracks: [{
    id: '1',
    title: 'Stronger',
    artist: 'Kanye West',
    duration: '5:11',
    imageUrl: 'https://i.scdn.co/image/ab67616d00001e02d9194aa18fa4c9362b47464f'
  }, {
    id: '2',
    title: "Don't Stop Me Now",
    artist: 'Queen',
    duration: '3:29',
    imageUrl: 'https://i.scdn.co/image/ab67616d00001e02056e90910cbaf5c5b892aeba'
  }, {
    id: '3',
    title: 'Titanium',
    artist: 'David Guetta, Sia',
    duration: '4:05',
    imageUrl: 'https://i.scdn.co/image/ab67616d00001e0213f2466b83507515291acce4'
  }, {
    id: '4',
    title: 'Eye of the Tiger',
    artist: 'Survivor',
    duration: '4:05',
    imageUrl: 'https://i.scdn.co/image/ab67616d00001e02e11a89a2b0707ba5104f3f44'
  }]
};
interface HomeContentProps {
  onPlaylistClick: (playlist: any) => void;
  onAlbumClick: (album: any) => void;
  onNavigate: (path: string) => void;
}
export const HomeContent = ({
  onPlaylistClick,
  onAlbumClick,
  onNavigate
}: HomeContentProps) => {
  const [showMoodModal, setShowMoodModal] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [generatedPlaylist, setGeneratedPlaylist] = useState(null);
  const [showPodcast, setShowPodcast] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  // Check if the viewport is mobile size
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    // Initial check
    checkIfMobile();
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
  const handleCreateMoodMix = mood => {
    setShowMoodModal(false);
    setIsGenerating(true);
    // Simulate playlist generation
    setTimeout(() => {
      setIsGenerating(false);
      setGeneratedPlaylist(MOCK_PLAYLIST);
    }, 3000);
  };
  const handlePodcastClick = podcast => {
    setShowPodcast(podcast);
  };
  if (generatedPlaylist) {
    return <MoodMixPlaylist mood={generatedPlaylist.mood} tracks={generatedPlaylist.tracks} onPlay={() => console.log('Play playlist')} onBack={() => setGeneratedPlaylist(null)} isMobile={isMobile} data-id="element-81" />;
  }
  if (showPodcast) {
    return <div className="bg-gradient-to-b from-[#1e1e1e] to-[#121212] min-h-full pb-24 p-6" data-id="element-82">
        <button onClick={() => setShowPodcast(null)} className="mb-6 flex items-center text-gray-400 hover:text-white" data-id="element-83">
          ← Back to Home
        </button>
        <div className="flex flex-col md:flex-row gap-6" data-id="element-84">
          <img src={showPodcast.imageUrl} alt={showPodcast.title} className="w-48 h-48 rounded-lg shadow-lg object-cover" data-id="element-85" />
          <div data-id="element-86">
            <span className="text-xs uppercase text-green-500 font-bold" data-id="element-87">
              Podcast Episode
            </span>
            <h1 className="text-3xl font-bold mt-2" data-id="element-88">{showPodcast.title}</h1>
            <h2 className="text-xl text-gray-400 mt-1" data-id="element-89">
              {showPodcast.showTitle}
            </h2>
            <div className="mt-4 flex items-center gap-2" data-id="element-90">
              <span className="text-sm" data-id="element-91">{showPodcast.publishedDate}</span>
              <span className="text-sm" data-id="element-92">•</span>
              <span className="text-sm" data-id="element-93">{showPodcast.duration}</span>
            </div>
            <p className="mt-6 text-gray-300" data-id="element-94">{showPodcast.description}</p>
            <div className="mt-8 flex gap-4" data-id="element-95">
              <button className="bg-green-500 text-black rounded-full p-3 hover:scale-105 transition-transform" data-id="element-96">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-97">
                  <path d="M8 5v14l11-7z" data-id="element-98" />
                </svg>
              </button>
              <button className="border border-gray-500 text-white rounded-full px-6 py-2 hover:border-white transition-colors" data-id="element-99">
                Save to Your Library
              </button>
              <button className="border border-gray-500 text-white rounded-full px-6 py-2 hover:border-white transition-colors" data-id="element-100">
                Share
              </button>
            </div>
          </div>
        </div>
      </div>;
  }
  // Mobile layout
  if (isMobile) {
    return <div className="bg-black min-h-full pb-32" data-id="element-101">
        <div className="px-4 pt-4" data-id="element-102">
          {/* Mood Mix Card for mobile */}
          <div className="bg-[#181818] rounded-lg p-4 hover:bg-[#282828] transition-colors cursor-pointer mb-6" onClick={() => setShowMoodModal(true)} data-id="element-103">
            <div className="flex items-center" data-id="element-104">
              <div className="w-16 h-16 rounded-md overflow-hidden bg-gradient-to-br from-purple-600 via-blue-500 to-green-400 mr-4 flex items-center justify-center" data-id="element-105">
                <svg className="w-8 h-8 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-106">
                  <path d="M9 18V5l12 13H9z" data-id="element-107" />
                </svg>
              </div>
              <div data-id="element-108">
                <h3 className="font-bold text-base" data-id="element-109">Create Your Mood Mix</h3>
                <p className="text-sm text-gray-400 pr-2" data-id="element-110">
                  Describe how you feel. Get a playlist that gets you.
                </p>
              </div>
            </div>
          </div>
          {/* Library Items / Playlists Grid */}
          <h2 className="text-xl font-bold mb-4" data-id="element-111">Your Library</h2>
          <div className="grid grid-cols-2 gap-4" data-id="element-112">
            {PLAYLISTS.map(playlist => <div key={playlist.id} className="aspect-square relative rounded-lg overflow-hidden" onClick={() => onPlaylistClick(playlist)} data-id="element-113">
                <img src={playlist.imageUrl || 'https://images.unsplash.com/photo-1611339555312-e607c8352fd7?w=300&h=300&fit=crop'} alt={playlist.title} className="w-full h-full object-cover" onError={e => {
              e.currentTarget.src = 'https://images.unsplash.com/photo-1611339555312-e607c8352fd7?w=300&h=300&fit=crop';
            }} data-id="element-114" />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3" data-id="element-115">
                  <h3 className="font-bold text-base truncate" data-id="element-116">
                    {playlist.title}
                  </h3>
                </div>
              </div>)}
            {ALBUMS.slice(0, 2).map(album => <div key={album.id} className="aspect-square relative rounded-lg overflow-hidden" onClick={() => onAlbumClick(album)} data-id="element-117">
                <img src={album.imageUrl || 'https://images.unsplash.com/photo-1629276301820-0f3eedc29fd0?w=300&h=300&fit=crop'} alt={album.title} className="w-full h-full object-cover" onError={e => {
              e.currentTarget.src = 'https://images.unsplash.com/photo-1629276301820-0f3eedc29fd0?w=300&h=300&fit=crop';
            }} data-id="element-118" />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3" data-id="element-119">
                  <h3 className="font-bold text-base truncate" data-id="element-120">
                    {album.title}
                  </h3>
                </div>
              </div>)}
          </div>
          {/* Movies section for mobile */}
          <h2 className="text-xl font-bold mt-8 mb-4" data-id="element-121">Movies</h2>
          <div className="grid grid-cols-1 gap-4 mb-8" data-id="element-122">
            <div className="relative aspect-video rounded-lg overflow-hidden" onClick={() => onNavigate('movies')} data-id="element-123">
              <img src="https://images.unsplash.com/photo-1536440136628-849c177e76a1?w=800&h=450&fit=crop" alt="Movies" className="w-full h-full object-cover" onError={e => {
              e.currentTarget.src = 'https://images.unsplash.com/photo-1485846234645-a62644f84728?w=800&h=450&fit=crop';
            }} data-id="element-124" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-4" data-id="element-125">
                <h3 className="text-lg font-bold" data-id="element-126">Explore Movies</h3>
              </div>
            </div>
          </div>
          {/* Popular Podcasts */}
          <h2 className="text-xl font-bold mb-4" data-id="element-127">Popular podcast episodes</h2>
          <div className="space-y-2" data-id="element-128">
            {PODCAST_EPISODES.map((episode, index) => <PodcastEpisode key={index} imageUrl={episode.imageUrl || 'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=300&h=300&fit=crop'} title={episode.title} description={episode.description} showTitle={episode.showTitle} duration={episode.duration} publishedDate={episode.publishedDate} hasVideo={episode.hasVideo} commentsCount={episode.commentsCount} onClick={() => handlePodcastClick(episode)} data-id="element-129" />)}
          </div>
        </div>
        {/* Make sure the modal is accessible on mobile */}
        <MoodMixModal isOpen={showMoodModal} onClose={() => setShowMoodModal(false)} onCreateMix={handleCreateMoodMix} data-id="element-130" />
        {isGenerating && <MoodMixLoading data-id="element-131" />}
      </div>;
  }
  // Desktop layout
  return <div className="bg-gradient-to-b from-[#1e1e1e] to-[#121212] min-h-full pb-24" data-id="element-132">
      <div className="relative" data-id="element-133">
        <div className="absolute inset-0 bg-gradient-to-b from-[#3533CD] to-[#121212] opacity-95" data-id="element-134" />
        <div className="relative z-10 px-4 pt-4" data-id="element-135">
          <h1 className="text-2xl font-bold mb-4" data-id="element-136">Good morning</h1>
          {/* Recent/Quick Access Grid */}
          <div className="grid grid-cols-2 gap-2 mb-6" data-id="element-137">
            <MoodMixCard onClick={() => setShowMoodModal(true)} isFirstTime={true} data-id="element-138" />
            {PLAYLISTS.map(playlist => <PlaylistCard key={playlist.id} title={playlist.title} imageUrl={playlist.imageUrl} large={false} onClick={() => onPlaylistClick(playlist)} data-id="element-139" />)}
          </div>
          {/* Popular Podcasts */}
          <div className="mb-6" data-id="element-140">
            <h2 className="text-xl font-bold mb-4" data-id="element-141">Popular podcast episodes</h2>
            <div className="space-y-2" data-id="element-142">
              {PODCAST_EPISODES.map((episode, index) => <PodcastEpisode key={index} imageUrl={episode.imageUrl || 'https://images.unsplash.com/photo-1478737270239-2f02b77fc618?w=300&h=300&fit=crop'} title={episode.title} description={episode.description} showTitle={episode.showTitle} duration={episode.duration} publishedDate={episode.publishedDate} hasVideo={episode.hasVideo} commentsCount={episode.commentsCount} onClick={() => handlePodcastClick(episode)} data-id="element-143" />)}
            </div>
          </div>
          {/* Recently Played */}
          <div data-id="element-144">
            <h2 className="text-xl font-bold mb-4" data-id="element-145">Recently played</h2>
            <div className="grid grid-cols-2 gap-3" data-id="element-146">
              {ALBUMS.map((album, index) => <AlbumCard key={index} title={album.title} artist={album.artist} imageUrl={album.imageUrl} onClick={() => onAlbumClick(album)} data-id="element-147" />)}
            </div>
          </div>
        </div>
      </div>
      <MoodMixModal isOpen={showMoodModal} onClose={() => setShowMoodModal(false)} onCreateMix={handleCreateMoodMix} data-id="element-148" />
      {isGenerating && <MoodMixLoading data-id="element-149" />}
    </div>;
};
const PlaylistCard = ({
  title,
  imageUrl,
  large,
  onClick
}) => <div className="bg-white/10 hover:bg-white/20 transition-all flex items-center rounded-xl overflow-hidden h-20 cursor-pointer group" onClick={onClick} data-id="element-150">
    <img src={imageUrl || 'https://images.unsplash.com/photo-1611339555312-e607c8352fd7?w=300&h=300&fit=crop'} alt={title} className="h-20 w-20 object-cover" data-id="element-151" />
    <span className="font-bold text-lg ml-4 flex-1 truncate pr-2" data-id="element-152">{title}</span>
    <div className="opacity-0 group-hover:opacity-100 transition-opacity pr-4" data-id="element-153">
      <div className="bg-green-500 rounded-full p-3 shadow-lg" data-id="element-154">
        <svg className="w-6 h-6 text-black" fill="currentColor" viewBox="0 0 24 24" data-id="element-155">
          <path d="M8 5v14l11-7z" data-id="element-156" />
        </svg>
      </div>
    </div>
  </div>;
const AlbumCard = ({
  title,
  artist,
  imageUrl,
  onClick
}) => <div className="bg-[#181818] rounded-xl p-4 hover:bg-[#282828] transition-colors cursor-pointer group" onClick={onClick} data-id="element-157">
    <div className="relative mb-4" data-id="element-158">
      <img src={imageUrl || 'https://images.unsplash.com/photo-1629276301820-0f3eedc29fd0?w=300&h=300&fit=crop'} alt={title} className="w-full aspect-square object-cover rounded-xl shadow-lg" onError={e => {
      e.currentTarget.src = 'https://images.unsplash.com/photo-1629276301820-0f3eedc29fd0?w=300&h=300&fit=crop';
    }} data-id="element-159" />
      <div className="absolute bottom-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-160">
        <div className="bg-green-500 rounded-full p-3 shadow-lg" data-id="element-161">
          <svg className="w-6 h-6 text-black" fill="currentColor" viewBox="0 0 24 24" data-id="element-162">
            <path d="M8 5v14l11-7z" data-id="element-163" />
          </svg>
        </div>
      </div>
    </div>
    <h3 className="font-bold text-base truncate" data-id="element-164">{title}</h3>
    <p className="text-gray-400 text-sm truncate mt-1" data-id="element-165">{artist}</p>
  </div>;